import React from 'react'
import { isBlank, find, get, titleize, sortBy } from 'lodash'
import Select from 'UI/Select'
import FiltersContext from '../contexts/Filter'

const chosenOptions = ({ isMulti, filters, selectOptions, filterName }) => {
  if (isMulti) { return filters[filterName] }

  return find(selectOptions, ['value', filters[filterName]])
}

const FilterSelect = ({ label, filterName, options, isMulti = true, sortOptions = true, className = 'col' }) => {
  const selectOptions = options

  return (
    <FiltersContext.Consumer>
      {({ filters, options, onChange }) => {
        let optionsToUse = selectOptions || options[filterName]
        if (sortOptions) { optionsToUse = sortBy(optionsToUse, 'label') }

        return (
          <div className={className}>
            <label>{label || titleize(filterName)}</label>
            <Select
              isMulti={isMulti}
              value={chosenOptions({ isMulti, filters, selectOptions, filterName })}
              options={optionsToUse}
              onChange={options => onChange({ ...filters, [filterName]: isBlank(options) ? 'All' : get(options, 'value', options) })}
            />
          </div>
        )
      }}
    </FiltersContext.Consumer>
  )
}

export default FilterSelect
